import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { SearchService } from '../../common/services/search.service';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { Store } from '@ngrx/store';
import { GaService } from '../../common/services/ga.service';
import * as _ from 'lodash';

import { UPDATESTATE } from '../reducers/search-state';

@Component({
  selector: 'search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.css']
})
export class SearchBarComponent implements OnInit {
  // we receive this from our parent component
  @Input() searchStateObj;

  // we send to our parent component that we switch filter
  @Output() searchingOnFilter: EventEmitter<any> = new EventEmitter();

  // Form
  public suggestionCtrl: FormControl = new FormControl();
  public mainSearchForm: FormGroup = new FormGroup({
    searchTerm: this.suggestionCtrl
  });

  // Typeahead
  public dataSource: Observable<any>;

  // Filters
  public filtersForResults = ['All Items', 'Hospitals', 'Systems', 'People'];

  // google analytics
  public searchType: String;

  // show spinner when user starts typing on input search
  searchingTypeahead;

  constructor(
    private searchService: SearchService,
    private store: Store<any>,
    private gaService: GaService
  ) {}

  ngOnInit() {
    this.setTypeahead();
  }

  setTypeahead() {
    this.dataSource = Observable.create((observer: any) => {
      let trimSearchTerm = this.searchStateObj.searchTerm.trim();
      this.searchingTypeahead = true;
      this.searchService
        .typeAhead({ searchTerm: trimSearchTerm, searchType: this.searchStateObj.typeaheadSuggest })
        .subscribe(
          ({ data }) => {
            this.searchingTypeahead = false;
            if (this.searchStateObj.searchTerm === '') {
              observer.next(data.searchSuggestion);
            } else {
              this.searchingTypeahead = false;
              let newSuggestionArray = data.searchSuggestion.slice(0);
              newSuggestionArray.unshift(this.searchStateObj.searchTerm);
              observer.next(newSuggestionArray);
            }
          },
          error => {
            this.searchingTypeahead = false;
            console.log(error);
          }
        );
    });
  }

  public typeaheadOnSelect(e: TypeaheadMatch): void {
    this.search();
  }

  toggle(event) {
    event.preventDefault();
    this.searchStateObj.filterResultsBy = event.target.innerHTML;
    this.searchStateObj.pageNum = 1;

    switch (this.searchStateObj.filterResultsBy) {
      case 'All Items':
        this.searchStateObj.filterResultsBy = 'All Items';
        this.searchStateObj.searchBy = 'all';
        this.searchStateObj.typeaheadSuggest = 'allSuggest';
        break;
      case 'Hospitals':
        this.searchStateObj.filterResultsBy = 'Hospitals';
        this.searchStateObj.searchBy = 'hospital';
        this.searchStateObj.typeaheadSuggest = 'hospitalSuggest';
        break;
      case 'Systems':
        this.searchStateObj.filterResultsBy = 'Systems';
        this.searchStateObj.searchBy = 'system';
        this.searchStateObj.typeaheadSuggest = 'systemSuggest';
        break;
      case 'People':
        this.searchStateObj.filterResultsBy = 'People';
        this.searchStateObj.searchBy = 'person';
        this.searchStateObj.typeaheadSuggest = 'personSuggest';
        break;
      default:
        this.searchStateObj.filterResultsBy = 'All Items';
        this.searchStateObj.searchBy = 'all';
        this.searchStateObj.typeaheadSuggest = 'allSuggest';
    }
    this.searchingOnFilter.emit('searchingOnFilter');
    this.setTypeahead();
    this.search();

    // google analytics
    this.gaService.addNavigationClick(this.searchStateObj.filterResultsBy);
  }

  search() {
    let citiesSelected = _.filter(this.searchStateObj.cities, function(o) {
      return o.selected;
    }).map(x => x.name);
    let countiesSelected = _.filter(this.searchStateObj.counties, function(o) {
      return o.selected;
    }).map(x => x.name);

    this.searchService
      .advancedSearch({
        searchTerm: this.searchStateObj.searchTerm,
        searchType: this.searchStateObj.searchBy,
        state: this.searchStateObj.stateSelectedAbbr,
        cities: citiesSelected,
        counties: countiesSelected,
        pageNum: 1
      })
      .subscribe(({ data }) => {
        this.searchingOnFilter.emit('endSearchOnFilter');
        this.store.dispatch({
          type: UPDATESTATE,
          payload: Object.assign({}, this.searchStateObj, {
            total: data.search.total,
            result: data.search.result
          })
        });
      });

    // google analytics
    this.searchType = !_.isEmpty(this.searchStateObj.state) ? 'advanced' : 'keyword';
    this.gaService.addAdvancedSearch(
      this.searchType,
      this.searchStateObj.searchTerm,
      this.searchStateObj.state,
      citiesSelected,
      countiesSelected
    );

    //emit we made a search
    this.searchService.newSearch.emit('New Search');
  }

  clearSearch() {
    this.searchStateObj.searchTerm = '';
  }

  onSubmit() {
    this.search();
  }
}



// WEBPACK FOOTER //
// ./src/app/search/search-bar/search-bar.component.ts